export default __webpack_public_path__ + "static/media/logo-white.2e44df04.png";